module.exports = {
	"header": {
		"logo": "Admin",
		"order_search": "Find order by identifier",
		"customer_search": "Find customer by project ID, email or phone",
		"server_time": "Server time",
		"exit": "Logout",
		"order_loading_failed": "Order loading failed",
		"show_unused": "Show unused",
		"language": "Language"
	}
};